import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'h3-persist-checkbox',
  templateUrl: './persist-checkbox.component.html',
  styleUrl: './persist-checkbox.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PersistCheckboxComponent {}
